import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import Status from 'components/Status';
import Type from 'components/Type';
import StepBar from 'components/StepBar';
import * as Icon from 'components/Icon';

import classes from './Card.module.scss';

interface IProps {
  title: string;
  image: string;
  category: string;
  gradient: {
    start: string;
    end: string;
  };
  type: string;
  number: number;
  date: string;
  step: {
    current: number;
    total: number;
    isVisible?: boolean;
  };
  status: {
    title: string;
    value: 'success' | 'warning' | 'danger';
  };
  className?: string;
  onClick?: () => void;
  showClose?: boolean;
  onClose?: () => void;
}

const Application: React.FC<IProps> = ({ title, image, category, gradient, type, number, date, step: { isVisible: stepIsVisible = true, ...step }, status, className, onClick, showClose, onClose }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(classes.wrapper, classes.wrapperApplication, className)}
      style={{ '--gradient-start': `${gradient.start}`, '--gradient-end': `${gradient.end}` } as React.CSSProperties}
      {...{ onClick }}
    >
      <div className={classes.image}>
        <img src={image} alt={category}/>
      </div>
      <div className={classes.content}>
        <div className={classes.tagList}>
          <Status className={classes.tagItem} variant={status.value}>{status.title}</Status>
          <Type className={classes.tagItem} variant="white">{type}</Type>
        </div>
        <div className={classes.number}>{t('application', { number })}</div>
        <div className={classes.category}>{category}</div>
        <div className={classes.title}>{title}</div>
        <div className={classes.date}>{t('application_date', { date })}</div>
        {stepIsVisible && (
          <StepBar {...step} size="middle" variant="blue"/>
        )}
        {showClose && (
          <div
            className={classes.close}
            onClick={(e) => {
              e.stopPropagation();
              onClose && onClose();
            }}
          >
            <Icon.System.Delete/>
          </div>
        )}
      </div>
    </div>
  );
};

export default Application;